var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4160_81521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 89.8569,
    width: 16,
    height: 16,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 89.8569H240V105.857H169V89.8569Z",
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 103.916C106.281 103.56 108.332 102.958 109.152 102.111C109.973 101.236 110.383 98.98 110.383 95.3433V58.9624C110.383 55.9546 109.918 53.9995 108.988 53.0972C108.086 52.1948 106.09 51.6343 103 51.4155V49.8569H126.338V51.4155C123.248 51.6343 121.238 52.1948 120.309 53.0972C119.379 53.9995 118.914 55.9546 118.914 58.9624V75.3276H144.385V58.9624C144.385 55.9546 143.934 53.9995 143.031 53.0972C142.129 52.1948 140.119 51.6343 137.002 51.4155V49.8569H160.34V51.4155C157.25 51.6343 155.24 52.1948 154.311 53.0972C153.408 53.9995 152.957 55.9546 152.957 58.9624V96.3276C152.957 99.3901 153.408 101.359 154.311 102.234C155.24 103.082 157.25 103.642 160.34 103.916V105.433H137.002V103.916C140.311 103.587 142.361 102.986 143.154 102.111C143.975 101.236 144.385 98.98 144.385 95.3433V79.019H118.914V96.3276C118.914 99.3901 119.379 101.359 120.309 102.234C121.238 103.109 123.248 103.669 126.338 103.916V105.433H103V103.916Z",
    fill: "#4C6170"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 150.857,
    width: 304,
    height: 9.14286,
    fill: "#0056A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4160_81521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(80 18.8569)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadline);
export default __webpack_public_path__ + "static/media/headline.4f47874c23ea730791aba7b39bc38cb3.svg";
export { ForwardRef as ReactComponent };